<div class="wrapper__contentComponent--expediente container my-5">
  <div class="d-flex flex-row justify-content-start mb-5">
    <div class="row align-items-center">
      <div class="col-12 col-md-3"></div>
      <div class="col-12 col-md-9">
        <h2 class="text-center h3-tipografia-govco mb-0">
          {{"formularios_enviados.titulo" | translate}}
        </h2>
      </div>
    </div>
  </div>
<div class="container-fluid mb-5">
  <div class="row g-3">
      <div class="col-12 col-md-3 d-flex flex-column flex-md-row align-items-md-center">
        <label class="me-md-2 mb-1 mb-md-0">{{"formularios_enviados.anio" | translate}}:</label>
        <select
          [(ngModel)]="selectedYear"
          class="col-md-6"
          class="form-select form-select-sm">
          <option [value]="0">{{"formularios_enviados.todos" | translate}}</option>
          <option *ngFor="let year of yearsFilter" [value]="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="col-12 col-md-3 d-flex flex-column flex-md-row align-items-md-center">
        <label class="me-md-2 mb-1 mb-md-0">{{"formularios_enviados.mes" | translate}}:</label>
        <select
          [(ngModel)]="selectedMonth"
          class="col-md-6"
          class="form-select form-select-sm">
          <option [value]="0">{{"formularios_enviados.todos" | translate}}</option>
          <option *ngFor="let month of monthFilter" [value]="month.valor">
            {{ month.nombre }}
          </option>
        </select>
      </div>

      <div class="col-12 col-md-3">
        <button (click)="filtrar()" class="btn-govco outline-btn-govco w-100"
          aria-label="Filtrar">
          {{"formularios_enviados.show_reportes" | translate}}
        </button>
      </div>
      <div class="col-12 col-md-3">
        <button 
          (click)="descargaMasiva()" 
          class="btn-govco outline-btn-govco w-100"
          [disabled]="!(selectedItems.length > 0)"
          aria-label="Descargar seleccionados">
          {{"formularios_enviados.descargar" | translate}}
        </button>
        
      </div>
    </div>
  </div>

  <div class="contenedor-tabla w-100">
    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      [datos]="data"
      [paginaActual]="paginaActual"
      [columnas]="columns"
      [multipleSelection]="true"
      [paginacion]="true"
      (selectedItemsChange)="handleSelectedItems($event)"
      [tamano]="tamanoPagina"
      [totalPaginas]="totalPaginas"
      [idColumn]="'id'"
      [tamanos]="[1, 5, 10, 20]"></app-table>
  </div>
</div>
